import { GetterTree } from "vuex";
import { ScenariosState } from "./types";
import { RootState } from "../types";
import { ScenarioAction } from "@/components/scenarios/types";

export const getters: GetterTree<ScenariosState, RootState> = {
    actions(state): ScenarioAction[] {
        return state.actions;
    },
};
